import React from 'react';
import PropTypes from 'prop-types';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import { Container, makeStyles } from '@material-ui/core';
import Page from 'src/components/Page';
import WorkerDemanders from './WorkerDemanders';
import RegisteredClients from './RegisteredClients';
import store from "../../../redux/store";
import NotAuthenticatedView from "../../errors/NotAuthenticatedView";


function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div role="tabpanel" hidden={value !== index}
      id={`scrollable-auto-tabpanel-${index}`}
      aria-labelledby={`scrollable-auto-tab-${index}`}
      {...other}>
      {value === index && (
        <Box p={3}>
          <Typography component={'span'} >{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `scrollable-auto-tab-${index}`,
    'aria-controls': `scrollable-auto-tabpanel-${index}`,
  };
}

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  }
}));

export default function WorkerDemanderManagement() {
  const classes = useStyles();
  const [value, setValue] = React.useState(0);  

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const state = store.getState();
  const {role } = state.authReducer;
  
  if (role != 'Admin' && role != 'Accountant')
  {
    return (<NotAuthenticatedView />);
  }

  return (
    <Page className={classes.root} title="Client Management">
     <Container maxWidth={false}>
      <AppBar position="static" color="default">
        <Tabs value={value} onChange={handleChange} indicatorColor="primary" textColor="primary" variant="scrollable" scrollButtons="auto" aria-label="scrollable auto tabs example">
          <Tab label="Worker Demanders" {...a11yProps(0)} />
          <Tab label="Registered Clients" {...a11yProps(1)} />
        </Tabs>
      </AppBar>
      <TabPanel value={value} index={0}>
        <WorkerDemanders />
      </TabPanel>
      <TabPanel value={value} index={1}>
        <RegisteredClients />
      </TabPanel>
    </Container>   
    </Page>
  );
}
